:host {
  @include reset-host;
}

:host .section {
  padding: rem(64) $gutter;

  @include mq('max', 'md') {
    padding: rem(50) $gutter-mobile;
  }

  &.has-white-background {
    background: $white;
  }

  &.has-purple-background {
    --paragraph-color: #{$white};
    background: $color-purple;
  }

  &.has-pink-background {
    background: $color-purple-fade;
  }

  &.has-blue-background {
    background: $color-blue-dark;
  }
}

:host .content {
  width: 100%;
  margin: 0 auto;

  &.is-xs-size {
    max-width: $max-width-tiny;
  }

  &.is-sm-size {
    max-width: $max-width-narrow;
  }

  &.is-md-size {
    max-width: $max-width-med;
  }

  &.is-lg-size {
    max-width: $max-width;
  }

  &.is-xl-size {
    max-width: $max-width-wide;
  }
}
